/** Google Calendar event has video conferencing (Meet or other video entry point). */
export function isGcalDigitalEvent(
  meet_link?: string | null,
  conference_data?: { entryPoints?: Array<{ entryPointType?: string; uri?: string }> } | null
): boolean {
  if (meet_link?.trim()) return true;
  const entryPoints = conference_data?.entryPoints;
  if (!Array.isArray(entryPoints)) return false;
  return entryPoints.some(
    (ep) => ep.entryPointType === 'video' && !!ep.uri?.trim()
  );
}

/** Google Calendar event has a physical location set. */
export function isGcalInPersonEvent(location?: string | null): boolean {
  return !!(location?.trim());
}

export function truncateGcalLocation(location: string, max = 18): string {
  const trimmed = location.trim();
  if (trimmed.length <= max) return trimmed;
  return `${trimmed.slice(0, max - 1)}…`;
}
